var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loaderWrapper"},[(_vm.size !== 'small')?_c('div',{staticClass:"m-loader m-loader--primary big-loader"}):_vm._e(),(_vm.size === 'small')?_c('div',{staticClass:"m-loader m-loader--sm m-loader--primary"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }